import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import AlertIconSvg from 'public/icons/alert.svg';

import styles from './_FormErrorBox.module.css';

type FormErrorBoxProps = {
	textField: Field<string>;
};

export function FormErrorBox(props: FormErrorBoxProps): JSX.Element {
	return (
		<aside className={styles.loginError}>
			<Text tag="span" field={props.textField} />

			<AlertIconSvg className={styles.alertIcon} />
		</aside>
	);
}
